import React from 'react'
import moment, { Moment } from 'moment'
import {
	Col,
	DatePicker,
	Divider,
	Form,
	FormInstance,
	Row,
	TimePicker,
} from 'antd'
import { BroadcastFormValues } from 'component/Broadcast/BroadcastDetails'

const { Item } = Form

interface Props {
	form: FormInstance<BroadcastFormValues>
	canEditBroadcast: boolean
}

const BroadcastFormSchedule: React.FC<Props> = ({ form, canEditBroadcast }) => {
	const disabledDate = (current: Moment) => {
		return current && current < moment().startOf('day')
	}

	const disabledHours = () => {
		const scheduleDate = form.getFieldValue('scheduleDate') as Moment | null

		if (scheduleDate !== null && scheduleDate.isSame(moment(), 'day')) {
			const hours = []
			// eslint-disable-next-line no-plusplus
			for (let i = 0; i <= moment().hour(); i++) {
				hours.push(i)
			}

			return hours
		}
		return []
	}

	const { isTimeSensitive } = form.getFieldsValue()

	if (isTimeSensitive === 'INSTANT') {
		return (
			<>
				<p className='custom-label'>
					Instant Broadcast are scheduled 15 minutes after confirmation. Use batch
					broadcast for scheduling in advance.
				</p>
				<Divider />
			</>
		)
	}

	return (
		<>
			<p className='custom-label'>Schedule Broadcast *</p>
			<Row gutter={16}>
				<Col span={8}>
					<Item
						name='scheduleDate'
						rules={[
							{
								required: true,
								message: 'Please select a data',
							},
						]}
					>
						<DatePicker
							size='large'
							format='DD/MM/YYYY'
							disabledDate={disabledDate}
							disabled={!canEditBroadcast}
						/>
					</Item>
				</Col>

				<Col span={8} hidden={form.getFieldValue('scheduleDate') === null}>
					<Item
						name='scheduleTime'
						trigger='onSelect'
						rules={[
							{
								required: true,
								message: 'Please select a time',
							},
						]}
					>
						<TimePicker
							size='large'
							format='hh:mm A'
							disabledHours={disabledHours}
							hideDisabledOptions
							showNow={false}
							disabled={!canEditBroadcast}
						/>
					</Item>
				</Col>
			</Row>
		</>
	)
}

export default BroadcastFormSchedule
